import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import CookieValue from "../../../utils/cookie_value";
import Cookies from "universal-cookie";
import UsersTable from "./UsersTable";
import FetchResource from "../../../utils/fetch_resource";
import { disable } from "debug";
import { options } from "colorette";

const api_base = process.env.API_URL;
const client_base = process.env.BASE_URL;

export default class UsersIndexMainContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      university_opts: [],
      filter: "btn-all" /**filter selected in the UI**/,
      reqFilter: "" /**filter params to send in the users fetch request**/,
      data_ready: false,
      display_error: false,
      notice: "",
      userRole: props.userRole,
      userId: props.userId,
      permissions: { create: false },
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
    this.fetchUsers()
      .then(() => {
        if (this._isMounted) {
          this.setState({ data_ready: true });
        }
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          const cookies = new Cookies();
          cookies.remove("user_auth");
          this.props.history.push("/log_in");
        } else {
          if (this._isMounted) {
            this.setState({ display_error: true });
          }
        }
      });
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (this._isMounted) {
      if (this.props !== prevProps) {
        this.setState({
          userRole: this.props.userRole,
          userId: this.props.userId,
        });
      }
      if (prevState.filter !== this.state.filter) {
        this.fetchUsers();
      }
    }
  };

  fetchUsers = (event) => {
    let { reqFilter } = this.state;
    return FetchResource(api_base + "users", reqFilter, this);
  };

  // fetchUsersOld = (opts, event) => {
  //   let {filter} = opts;
  //   return new Promise(
  //     (resolve, reject) => {
  //       let url = api_base + "users"
  //       if (filter) {
  //         url += filter;
  //       }
  //       try {
  //         fetch(url, {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //             "Accept": "application/json",
  //             "Authorization": "Bearer " + CookieValue(),
  //           },
  //         }).then(
  //           res => {
  //             if(res.status === 201 || res.status === 200) {
  //               res.json().then(
  //                 data => {
  //                   this.setState({
  //                     users: data.users,
  //                     university_opts: data.university_opts,
  //                     permissions: data.permissions,
  //                   })
  //                   resolve()
  //                 }
  //               )
  //             } else {
  //               reject(res.statusText)
  //             }
  //           }
  //         )
  //       } catch (err) {
  //         reject(err)
  //       }
  //     }
  //   )
  // }

  filterUsers = (opts, e) => {
    this.fetchUsers(opts)
      .then(() => {
        this.setState({ data_ready: true, display_error: false });
      })
      .catch((err) => {
        if (err === "Unauthorized") {
          const cookies = new Cookies();
          cookies.remove("user_auth");
          this.props.history.push("/log_in");
        } else {
          this.setState({ display_error: true });
        }
      });
  };

  api_call = (url, reqOptions) => {
    return new Promise((resolve, reject) => {
      try {
        fetch(url, reqOptions).then((res) => {
          res.json().then((data) => resolve(data));
        });
      } catch (err) {
        reject(err);
      }
    });
  };

  handleFilterBtnClick = (opts, event) => {
    const { filter, btnId } = opts;
    this.setState({ filter: btnId, reqFilter: filter });
  };

  handleDropdownFilterChange = (opts, event) => {
    const filter = event.target.value;
    this.setState({ filter: filter, reqFilter: filter });
  };

  render() {
    let {
      users,
      filter,
      university_opts,
      userRole,
      userId,
      permissions,
      notice,
      display_error,
    } = this.state;

    const isAdmin = userRole === "ADMIN";
    const univ_opts = university_opts.map((univ) => {
      let opt_filter = "lookup_table[id]=" + univ.id;
      return (
        <option value={opt_filter} key={"univ" + univ.id}>
          {univ.name}
        </option>
      );
    });
    const noticeHtml = (
      <div className="alert alert-danger card" role="alert">
        {notice}
      </div>
    );

    return (
      <div className="container">
        {display_error ? noticeHtml : ""}
        <div
          className="btn-toolbar mt-2 mb-2 d-flex flex-row justify-content-between"
          role="toolbar"
          aria-label="Toolbar with user management links"
        >
          <div>
            <div
              className="btn-group mr-2"
              role="group"
              aria-label="User filters"
            >
              <button
                id="btn-all"
                type="button"
                className={
                  "btn btn-info" + (filter == "btn-all" ? " disabled" : "")
                }
                onClick={(e) =>
                  this.handleFilterBtnClick({ filter: "", btnId: "btn-all" })
                }
              >
                All
              </button>
              <button
                id="btn-eguniv"
                type="button"
                className={
                  "btn btn-info" + (filter == "btn-eguniv" ? " disabled" : "")
                }
                onClick={(e) =>
                  this.handleFilterBtnClick(
                    {
                      filter: "lookup_table[table_type]=eguniv",
                      btnId: "btn-eguniv",
                    },
                    e
                  )
                }
              >
                Egyptian Faculty
              </button>
              <button
                id="btn-usuniv"
                type="button"
                className={
                  "btn btn-info" + (filter == "btn-usuniv" ? " disabled" : "")
                }
                onClick={(e) =>
                  this.handleFilterBtnClick(
                    {
                      filter: "lookup_table[table_type]=usuniv",
                      btnId: "btn-usuniv",
                    },
                    e
                  )
                }
              >
                US Faculty
              </button>
            </div>
            <select
              id="univ-select-dd"
              className="btn btn-info"
              value={filter}
              onChange={(e) => this.handleDropdownFilterChange({}, e)}
            >
              <option value="">Filter by university</option>
              {univ_opts}
            </select>
            <div
              className="btn-toolbar mt-2 mb-2 d-flex flex-row justify-content-between"
              role="toolbar"
              aria-label="Toolbar with user management links"
            >
              <div
                className="btn-group mr-2"
                role="group"
                aria-label="User filters"
              >
                <button
                  id="btn-all-auth"
                  type="button"
                  className={
                    "btn btn-info" +
                    (filter == "btn-all-auth" ? " disabled" : "")
                  }
                  onClick={(e) =>
                    this.handleFilterBtnClick(
                      {
                        filter: "auth=all",
                        btnId: "btn-auth-all",
                      },
                      e
                    )
                  }
                >
                  All
                </button>
                <button
                  id="btn-auth"
                  type="button"
                  className={
                    "btn btn-info" + (filter == "btn-auth" ? " disabled" : "")
                  }
                  onClick={(e) =>
                    this.handleFilterBtnClick(
                      {
                        filter: "auth=true",
                        btnId: "btn-auth",
                      },
                      e
                    )
                  }
                >
                  Authorized
                </button>
                <button
                  id="btn-noauth"
                  type="button"
                  className={
                    "btn btn-danger" +
                    (filter == "btn-noauth" ? " disabled" : "")
                  }
                  onClick={(e) =>
                    this.handleFilterBtnClick(
                      {
                        filter: "auth=false",
                        btnId: "btn-noauth",
                      },
                      e
                    )
                  }
                >
                  Unauthorized
                </button>
              </div>
            </div>
          </div>
          <div>
            {permissions["create"] ? (
              <div
                className="btn-group mr-2"
                role="group"
                aria-label="User management actions"
              >
                <a href="../user/new">
                  <button id="newUsrBtn" className="btn btn-primary">
                    New User
                  </button>
                </a>
              </div>
            ) : (
              ""
            )}
            <div
              className="btn-group"
              role="group"
              aria-label="User management actions"
            >
              <a href={client_base + "changepw/" + userId}>
                <button className="btn btn-primary">Change My Password</button>
              </a>
            </div>
          </div>
        </div>
        <UsersTable users={users} canEdit={isAdmin} permissions={permissions} />
      </div>
    );
  }
}
